import script from "./Adjudication.vue?vue&type=script&setup=true&lang=js"
export * from "./Adjudication.vue?vue&type=script&setup=true&lang=js"

import "./Adjudication.vue?vue&type=style&index=0&id=b1d640c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1d640c8"]])

export default __exports__